import * as _ from "lodash";
import { put, select } from "redux-saga/effects";

import actions from "@/actions";

/**
 * Deletes the currently selected lights from the map.
 *
 * @yields Selects current lights and dispatches deletion actions.
 */
function* deleteLights() {
    try {
        const getMode = (name) => (name === "view" ? "global" : "mode");
        const { mode, lights, selectedLights } = yield select(({ map }) => ({
            mode: getMode(map.general.mode.name),
            selectedLights: map.general.selectedLights,
            lights: _.values(
                map.values[getMode(map.general.mode.name)].present.lights,
            ),
        }));
        const deletedLights = _.filter(lights, (light) =>
            _.some(
                selectedLights,
                (selectedLight) => selectedLight === light.uniqueId,
            ),
        );
        yield put(actions.map.values[mode].deleteLights(deletedLights));
        yield put(actions.map.general.deselectAllLights());
    } catch (err) {
        // eslint-disable-next-line no-console
        console.log("err on changing mode:", err);
    }
}

export default deleteLights;
